import { queryOptions } from '@tanstack/react-query';

import api from '@lib/api/client';

export interface TenantConfig {
  id: string;
  host: string;
  type: 'pharmhub' | 'medhub';
  theme: string;
  // Feature flag：是否開放訂單取消功能（由 BFF TenantConfig 帶出，預設 false）
  orderCancelEnabled: boolean;
}

// BFF response structure wraps tenant in { tenant: TenantConfig }
interface TenantCurrentResponse {
  tenant: TenantConfig;
}

// Query options factory pattern
export const tenantQueryOptions = () =>
  queryOptions({
    queryKey: ['tenant'],
    queryFn: async () => {
      const response = await api.get<TenantCurrentResponse>('/tenants/current');
      return response.data.tenant;
    },
    staleTime: Infinity, // Tenant config rarely changes
    // Design Decision: No retry feedback UI - users should contact support if loading persists
    // Rationale: Intentional design to encourage user-initiated support contact rather than
    // displaying technical retry messages that may confuse non-technical users
    // @see PR #62 review comment
    retry: true, // Keep retrying until successful - tenant is required for app to function
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff, max 30s
  });
